// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1ksTh","colMin":"styles_colMin__39lgE","colCheckbox":"styles_colCheckbox__3D8w-"};